import { render } from "./Header.vue?vue&type=template&id=da53527c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=da53527c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3710787608/src/iristravel-hotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da53527c"]])

export default __exports__